(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["button"] && !Shopify.designMode) return;
  try {
    // JavaScript para hacer que el botón sea arrastrable
  document.addEventListener("DOMContentLoaded", function() {
    const button = document.querySelector('.draggable-button'); // Selecciona el botón con la clase "draggable-button"
    
    // Hacer el botón arrastrable
    if (button) {
      button.setAttribute('draggable', 'true');
      
      button.addEventListener('dragstart', function(event) {
        event.dataTransfer.setData('text/plain', button.id); // Usa el ID del botón para identificarlo
        button.style.opacity = '0.5'; // Cambia la opacidad mientras se arrastra
      });

      button.addEventListener('dragend', function(event) {
        button.style.opacity = '1'; // Restaura la opacidad cuando se deja de arrastrar
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
